// extracted by mini-css-extract-plugin
export default {"teamContainer":"Team_teamContainer__lBKnk","teamHeader":"Team_teamHeader__Awzmh","teamContent":"Team_teamContent__aE0UJ","noData":"Team_noData__djKHi"};